import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';

import { AuthenticationService } from '@usercommon/service/authentication.service';
import { UserService } from '@sharedcommon/services/user.service';
import { Observable, of } from 'rxjs';
import { filter, switchMap } from 'rxjs/operators';

@Injectable()
export class EnsureUserAuthGuard implements CanActivate {

  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    private readonly userService: UserService,
    private readonly msalBroadcastService: MsalBroadcastService
  ) { }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        switchMap(() => {
          const azureAccount = this.authService.setAndGetAzureAccount();
          if (azureAccount) {
            const claims: any = azureAccount.idTokenClaims;
            const claimsValidation = this.authService.validateClaims(claims);
            if (!claimsValidation.valid) {
              this.router.navigate(['/error'], { queryParams: { reason: claimsValidation.error } });
              return of(false);
            }
            this.userService.setUser(claims);
            this.userService.changeLang();
            return of(true);
          }

          this.router.navigate(['/logout']);
          return of(false);
        })
      );
  }
}
